import _ from 'lodash'

export const useBoyfriendtv = () => {
	const {getFileNameFromUrl, extFetch} = useHelpers()
	/**
	 * Extract video URL from boyfriendtv page
	 */
	async function getVideoFromUrl(url) {
		console.log('[useBoyfriendtv] Processing URL:', url);
		try {
			// If it's already a direct video URL, return it
			if (url.match(/\.(mp4|webm|m3u8?)(\?|$)/i)) {
				let isHLS = !!url.match(/\.m3u8?(\?|$)/i)
				console.log('[useBoyfriendtv] Direct URL detected. isHLS:', isHLS);
				let fileName = getFileNameFromUrl(url) || 'video.mp4'
				if (isHLS && !fileName.endsWith('.mp4')) {
					fileName = fileName.replace(/\.m3u8?$/, '') + '.mp4'
				}

				return {
					website: 'boyfriendtv.com',
					type: 'video',
					url: url,
					fileName: fileName,
					headers: {
						'Referer': 'https://www.boyfriendtv.com/',
						'Origin': 'https://www.boyfriendtv.com'
					},
					previewUrl: url,
					thumbnail: null,
					canView: true,
					hls: isHLS
				}
			}

			// Otherwise, try to fetch the page and extract video URL
			try {
				let response = await extFetch(url, {
					method: 'GET',
					headers: {
						'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36',
						'Referer': 'https://www.boyfriendtv.com/'
					}
				})

				if (response && response.body) {
					let html = typeof response.body === 'string' ? response.body : (response.body.toString ? response.body.toString() : String(response.body))
					
					// Extract sources from the script tag
					const sourcesMatch = html.match(/sources\s*=\s*(\[.*?\])/s)
					
					let sources = []
					if (sourcesMatch) {
						try {
							let jsonStr = sourcesMatch[1].trim()
							if (jsonStr.endsWith(';')) jsonStr = jsonStr.slice(0, -1)
							sources = JSON.parse(jsonStr)
						} catch (e) {
							const srcMatches = sourcesMatch[1].match(/"src":"(.*?)"/g)
							if (srcMatches) {
								sources = srcMatches.map(m => {
									const src = m.match(/"src":"(.*?)"/)[1]
									return { src, desc: 'unknown' }
								})
							}
						}
					}

					console.log('[useBoyfriendtv] Found sources:', sources.length);

					if (sources && sources.length > 0) {
						const qualities = ['1080p', '720p', '480p', '360p', '240p']
						let selectedSource = null
						for (const q of qualities) {
							selectedSource = sources.find(s => s.desc === q)
							if (selectedSource) break
						}
						if (!selectedSource) selectedSource = sources[0]

						if (selectedSource && selectedSource.src) {
							let videoUrl = selectedSource.src.replace(/\\\//g, '/')
							console.log('[useBoyfriendtv] Selected source URL:', videoUrl);
							
							let fileName = getFileNameFromUrl(videoUrl) || 'video.mp4'
							// Force .mp4 extension for the final file
							if (!fileName.endsWith('.mp4')) {
								fileName = fileName.replace(/\.m3u8?$/, '') + '.mp4'
							}
							
							return {
								website: 'boyfriendtv.com',
								type: 'video',
								url: videoUrl,
								fileName: fileName,
								headers: {
									'Referer': url,
									'Origin': 'https://www.boyfriendtv.com'
								},
								previewUrl: videoUrl,
								thumbnail: null,
								canView: true,
								quality: selectedSource.desc || 'unknown',
								hls: true // Force HLS for BoyfriendTV
							}
						}
					}
				}
			} catch (fetchError) {
				console.warn('[useBoyfriendtv] Could not fetch page to extract video URL:', fetchError)
			}

			// Fallback
			return {
				website: 'boyfriendtv.com',
				type: 'video',
				url: url,
				fileName: 'video.mp4',
				previewUrl: url,
				thumbnail: null,
				canView: true
			}
		} catch (error) {
			console.error('Error fetching video from URL:', error)
			return {
				website: 'boyfriendtv.com',
				type: 'video',
				url: url,
				fileName: 'video.mp4',
				previewUrl: url,
				thumbnail: null,
				canView: true
			}
		}
	}

	/**
	 * Process multiple URLs and extract videos
	 */
	async function getVideosFromUrls(urls) {
		let validUrls = urls
			.split('\n')
			.map(url => url.trim())
			.filter(url => url && url.length > 0)

		let results = await Promise.all(
			validUrls.map(url => getVideoFromUrl(url))
		)

		return results.map((media, index) => ({
			...media,
			id: `boyfriendtv-${Date.now()}-${index}`,
			source: 'boyfriendtv'
		}))
	}

	return {
		getMedia: async (form) => {
			if (form.urls) return getVideosFromUrls(form.urls)
			if (form.url) {
				let media = await getVideoFromUrl(form.url)
				media.id = `boyfriendtv-${Date.now()}`
				media.source = 'boyfriendtv'
				return [media]
			}
			return []
		},
		getVideoFromUrl,
		getVideosFromUrls
	}
}
